import {useAuthenticationValue} from "@lectra/react-authentication";
import {ProfileAuth0Data} from "../ui-components/ProfileAuth0Data";

export const ProfileAuth0 = () => {
    const { user } = useAuthenticationValue()

    return (
        <ProfileAuth0Data user={user}/>
    );
};

